/* eslint-disable react/jsx-no-constructed-context-values */
import type { AnalyticsConfig } from '@/pageConfig/car/us/en';
import type React from 'react';
import { createContext, useCallback, useState } from 'react';

interface CTAData {
  uuid: string;
  isVisible: boolean;
}

const DEFAULT_ANALYTICS_CONFIG: AnalyticsConfig = {
  page: 'car',
  product: 'car',
  dataSource: 'car',
  ctaId: 'gtm_button_car_check_prices',
  faqViewedEvent: 'car_faq_section.viewed',
  videoClickedEvent: 'car_page.video.clicked',
};

interface ICarLandingPageContext {
  isEmbeddedPage: boolean;
  isHidingHeaderCTA: boolean;
  analytics: AnalyticsConfig;
  registerMainCta: (ref: string, isVisible: boolean) => void;
  setIsMainCtaVisible: (ref: string, isVisible: boolean) => void;
  setIsHidingHeaderCTA: (value: boolean) => void;
}

export const CarPageContext = createContext<ICarLandingPageContext>({} as ICarLandingPageContext);

export const CarPageContextProvider: React.FC<
  React.PropsWithChildren<{
    isEmbeddedPage?: boolean;
    analytics?: AnalyticsConfig;
  }>
> = ({ isEmbeddedPage = false, analytics = DEFAULT_ANALYTICS_CONFIG, children }) => {
  const [mainCtas, setMainCtas] = useState<CTAData[]>([]);
  const [isHidingHeaderCTA, setIsHidingHeaderCTA] = useState(true);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const registerMainCta = useCallback((uuid: string, isVisible: boolean): void => {
    setMainCtas([...mainCtas, { uuid, isVisible }]);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const setIsMainCtaVisible = useCallback((uuid: string, isVisible: boolean): void => {
    const newArray = mainCtas.map(item => (item.uuid === uuid ? { uuid, isVisible } : item));
    // setMainCtas(newArray);
    setIsHidingHeaderCTA(newArray.find(item => item.isVisible) != null);
  }, []);

  return (
    <CarPageContext.Provider
      value={{
        isEmbeddedPage,
        isHidingHeaderCTA,
        analytics,
        setIsMainCtaVisible,
        registerMainCta,
        setIsHidingHeaderCTA,
      }}
    >
      {children}
    </CarPageContext.Provider>
  );
};
